export const isValidAmount = (val?: string | number | undefined | null): boolean => {
  // If null or undefined
  if (val == null) {
    return false;
  }

  let valAsNumber: number = val as number;

  // If the value is a string, remove the leading '$' symbol if applicable.
  // Some merchants may pass in $30
  if (typeof val === 'string') {
    valAsNumber = Number(val.replace('$', ''));
  }

  // If NaN or number is less than 0
  if (isNaN(valAsNumber) || valAsNumber < 0) {
    return false;
  }

  return true;
};